export default [
  {
      text: 'Tipo',
      value: 'type',
  },
  {
      text: 'Folio',
      value: 'dte_number',
  },
  {
      text: 'FECHA EMISIÓN',
      value: 'emission_date',
      format: 'date',
  },
  {
      text: 'ESTADO',
      value: 'state',
  },
  {
      text: 'NETO',
      value: 'net_total',
      format: 'currency',
  },
  {
      text: 'IVA',
      value: 'iva',
      format: 'currency',
  },
  {
      text: 'TOTAL',
      value: 'total',
      format: 'currency',
  },
]
